/**
 * Max KPIs a watchlist shows / can pin. Single source for the body's row cap and
 * the editor's selection cap (mirrors `KpiWatchlistParamsSchema`'s `kpiIds.max(6)`
 * in `@playbookai/widget-schemas`), so the two can't drift.
 */
export const MAX_WATCHLIST_KPIS = 6;
